export default {
    APP_VERIFICAR: '/Cuenta/verificar', 

}